import { STATUS_LABELS } from "../lib/api";

export default function StatusBadge({ status, "data-testid": testId }) {
  const label = STATUS_LABELS[status] || status;
  return (
    <span className={`status-pill status-${status}`} data-testid={testId}>
      {label}
    </span>
  );
}
